import { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import { getOnboardingMessages } from '@/lib/onboardingMessages';

const EVA_LOGO_URL = '/eva-icon-square.png';
const MESSAGE_INTERVAL_MS = 1200;
const TOTAL_DURATION_MS = 4800;

/**
 * A fixed-duration transition shown between password submission and landing
 * on the new tenant's dashboard, while the backend best-effort seeds a
 * starter KB document from PDL data (see kb_seed_service.py). This does NOT
 * poll real ingestion completion -- that can take up to ~20-30s, and
 * blocking the user that long is worse UX than letting them in a few
 * seconds early; the doc simply finishes ingesting moments after they land.
 */
export default function OnboardingLoadingScreen({ companyName, onDone }) {
  const messages = getOnboardingMessages(companyName);
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const messageTimer = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, MESSAGE_INTERVAL_MS);
    const doneTimer = setTimeout(() => {
      onDone();
    }, TOTAL_DURATION_MS);
    return () => {
      clearInterval(messageTimer);
      clearTimeout(doneTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-secondary flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="pt-12 pb-12 text-center">
          <img src={EVA_LOGO_URL} alt="Eva" className="w-16 h-16 rounded-xl mx-auto mb-5" />
          <Loader2 className="w-8 h-8 animate-spin mx-auto text-primary mb-5" />
          <h2 className="text-xl font-semibold text-foreground">{messages[messageIndex]}</h2>
          <p className="text-muted-foreground mt-2.5">Getting started with Eva.</p>
        </CardContent>
      </Card>
    </div>
  );
}
